import React from "react";
import { Modal } from "antd";
import { Check } from "lucide-react";
import { LoadingOutlined } from "@ant-design/icons";

interface BaseModalProps {
  title: string;
  open: boolean;
  onCancel: () => void;

  formId: string;
  isSubmitting?: boolean;

  submitLabel?: string;
  cancelLabel?: string;

  children: React.ReactNode;
  error?: string | null;

  afterClose?: () => void;
}

export default function BaseModal({
  title,
  open,
  onCancel,
  formId,
  isSubmitting = false,
  submitLabel = "Save",
  cancelLabel = "Cancel",
  children,
  error,
  afterClose,
}: BaseModalProps) {
  const finalSubmitLabel = isSubmitting ? "Saving..." : submitLabel;

  return (
    <Modal
      title={title}
      open={open}
      onCancel={isSubmitting ? undefined : onCancel}
      afterClose={afterClose}
      destroyOnClose
      maskClosable={!isSubmitting}
      footer={
        <div className="flex justify-end gap-2 mt-6">
          <button
            onClick={onCancel}
            className="btn btn-gray"
            disabled={isSubmitting}
          >
            {cancelLabel}
          </button>

          <button
            form={formId}
            type="submit"
            className="btn btn-green"
            disabled={isSubmitting}
          >
            {isSubmitting ? <LoadingOutlined /> : <Check size={14} />}
            <span>{finalSubmitLabel}</span>
          </button>
        </div>
      }
      className="custom-modal"
    >
      {error && (
        <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded-lg text-sm">
          {error}
        </div>
      )}

      <div className={error ? "mt-2" : "mt-4"}>{children}</div>
    </Modal>
  );
}
